import { includes } from 'ramda';

import { medicationDeliveryConstants } from '@ui/routes/shared/MedicationDeliveryStep';

export const isCapsuleEligible = (deliveryMethods: string[]) => {
	const capsuleEligible =
		deliveryMethods?.length > 0 &&
		includes(medicationDeliveryConstants.CAPSULE_METHOD, deliveryMethods);
	return capsuleEligible;
};
